import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

// Import all components
import App from "./pages/app";
import Setting from "./Componants/Setting/Setting";
import Managecountry from "./pages/Setting-pages/Manage-country/Manage-country";
import Manageregion from "./pages/Setting-pages/Manage-region/Manage-region";
import Managezone from "./pages/Setting-pages/Manage-zone/Mainegezone";
import Managestate from "../src/pages/Setting-pages/Manage-state/Managestate";
import Managedistrict from "./pages/Setting-pages/Manage-District/Managedistrict";
import Managecity from "./pages/Setting-pages/Manage-city/Managecity";
import Managelocality from "./pages/Setting-pages/Manage-Locality/Managelocality";
import Bulkuploadlocality from "./pages/Setting-pages/Bulkupload-locality/Bulkuploadlocality";
import Managetexmaster from "./pages/Setting-pages/Manage-Tax-Master/Managetexmaster";
import TaxCategoryName from "./pages/Setting-pages/Tax-Category-Name/TaxCategoryName";
import Managebrand from "./pages/Setting-pages/Manage-Brand/Managebrand";
import Manageproductcatgeory from "./pages/Setting-pages/Manage-Product-Catgeory/Manageproductcatgeory";
import Managemodel from "./pages/Setting-pages/Manage-Model/Managemodel";
import Managesku from "./pages/Setting-pages/Manage-SKU/Managesku";
import Serialvendorwarranty from "./pages/Setting-pages/Serial-Vendor-Warranty/Serialvendorwarranty";
import Customercategory from "./pages/Setting-pages/Customer-Category/Customercategory";
import Viewentitymapping from "./pages/Setting-pages/View-Entity-Mapping/Viewentitymapping";
import Manageentitycreditterm from "./pages/Setting-pages/Manage-Entity-Credit-Term/Manageentitycreditterm";
import Manageentitycredittermmain from "./pages/Setting-pages/Manage-Entity-Credit-Term/Manageentitycredittermmain";
import Uploadmanageuser from "./pages/Setting-pages/Upload-Manage-User/Uploadmanageuser";
import Uploadentitydetail from "./pages/Setting-pages/Upload-Entity-Detail/Uploadentitydetail";
import Usermaster from "./pages/Setting-pages/User-master/Usermaster";
import Entitymapping from "./pages/Setting-pages/Entity-Mapping/Entitymapping";
import Customerservice from "./pages/Sidemenu-pages/Call-centre/Master-Customer/Customerservice";
import Logcomplaint from "./pages/Sidemenu-pages/Call-centre/Log-Complaint/Logcomplaint";
import Logproductcomplaint from "./pages/Sidemenu-pages/Support-pages/Log-Product-Complaint/Logproductcomplaint";
import Jobsheets from "./pages/Sidemenu-pages/Service-center/Jobsheet/Jobsheets/Jobsheets";
import Jobsheet from "./pages/Sidemenu-pages/Service-center/Jobsheet/Jobsheet/Jobsheet";
import Jobsheet2 from "./pages/Sidemenu-pages/Service-center/Jobsheet/Jobsheet2/Jobsheet2";
import Dashboard from "./pages/Sidemenu-pages/Dashboard/Dashboard/Dashboard";
import Amcdashboard from "./pages/Sidemenu-pages/AMC-Dashboard/Amcdashboard";
import Amc from "./pages/Setting-pages/AMC/Amc";
import CreateCustomerAmc from "./pages/Sidemenu-pages/AMC-Dashboard/AMC-CN/CreateCustomerAmc";
import Searchdealercustomer from "./pages/Sidemenu-pages/Repair/Search-Dealercustomer/Searchdealercustomer";
import One from "./pages/Sidemenu-pages/Repair/Popup-Page/Allocated-one/One";
import Bufferstockallocation from "./pages/Sidemenu-pages/Repair/Buffer-stock-allocation/Bufferstockallocation";
import Engineerpartconsumption from "./pages/Sidemenu-pages/Reports/Inventory Report/Engineer-Part-Consumption/Engineerpartconsumption";
import Managetaxtype from "./pages/Setting-pages/Manage-Tax-type/Managetaxtype";
import Managesparepartmapping from "./pages/Setting-pages/Manage-spare-part-mapping/Managesparepartmapping";
import Closecallreport from "./pages/Sidemenu-pages/Reports/Service report/Close-call-report/Closecallreport";
import Callupdationmobile from "./pages/Sidemenu-pages/Reports/Service report/Call-updation-mobile/Callupdationmobile";
import Stockinhand from "./pages/Sidemenu-pages/Reports/Inventory Report/Stock-Inhand/Stockinhand";
import Changepassword from "./pages/Sidemenu-pages/Help-Page/Change-password/Changepassword";
import Jobsheetsearch from "./pages/Sidemenu-pages/Help-Page/Jobsheet-search/Jobsheetsearch";
import Dashboardsuperadmin from "./pages/Sidemenu-pages/Super-admin/Dashboard/Dashboardsuperadmin";
import Financialdashboard from "./pages/Sidemenu-pages/Super-admin/Financial Dashboard/Financialdashboard";
import Dashboardtrails from "./pages/Sidemenu-pages/Super-admin/Trails/Dashboardtrails";
import Subscriptions from "./pages/Sidemenu-pages/Super-admin/Subscriptions/Subscriptions";
import CreateOrganizations from "./pages/Sidemenu-pages/CreateOrganizations/CreateOrganizations";
import CreateOrganizationsView from "./pages/Sidemenu-pages/CreateOrganizations/CreateOrganizationsView";
import CreateSubscription from "./pages/Sidemenu-pages/CreateSubscription/CreateSubscription";
import CreateSubscriptionView from "./pages/Sidemenu-pages/CreateSubscription/CreateSubscriptionView";
import Manageproductsubcatgeory from "./pages/Setting-pages/Manage-product-subcatgeory/Manageproductsubcatgeory";
import SparePartCreation from "./pages/Setting-pages/Manage-part-master/Managepartmaster";
import InventoryDashboard from "./pages/Sidemenu-pages/Inventory Dashboard/InventoryDashboard";
import StockGRN from "./pages/Sidemenu-pages/Inventory Dashboard/StockGRN";
import ChangePasswordAdmin from "./pages/Sidemenu-pages/Help-Page/Change-password/ChangePasswordAdmin";
import JobReport from "./pages/Sidemenu-pages/Reports/Service report/Open-Call-Detail/JobReport";
import ModuleMaster from "./pages/Setting-pages/Module-master/ModuleMaster";
import ChangeAdminPassword from "./pages/Sidemenu-pages/Help-Page/ChangeAdminPassword/ChangeAdminPassword";
import RepairUpdate from "./pages/Sidemenu-pages/Repair/Dashboard/RepairUpdate";
import JobsheetView from "./pages/Sidemenu-pages/Repair/Dashboard/JobsheetView";
import ServiceDashboard from "./pages/Sidemenu-pages/Service-Dashboard/ServiceDashboard";
import CallDashboard from "./pages/Sidemenu-pages/Repair/Dashboard/CallDashboard";

/**
 * Route Mapping: moduleUrl -> Component
 */
const routeMapping = {
  "/": <App />,
  "/dashboard": <Dashboard />,
  "/Setting": <Setting />,
  "/managecountry": <Managecountry />,
  "/Manageregion": <Manageregion />,
  "/Managezone": <Managezone />,
  "/Managestate": <Managestate />,
  "/Managedistrict": <Managedistrict />,
  "/Managecity": <Managecity />,
  "/Managelocality": <Managelocality />,
  "/Bulk-uploadlocality": <Bulkuploadlocality />,
  "/Managetexmaster": <Managetexmaster />,
  "/TaxCategoryName": <TaxCategoryName />,
  "/Managetaxtype": <Managetaxtype />,
  "/Managebrand": <Managebrand />,
  "/Manageproductcatgeory": <Manageproductcatgeory />,
  "/Managemodel": <Managemodel />,
  "/Managesku": <Managesku />,
  "/Managepartmaster": <SparePartCreation />,
  "/Managesparepartmapping": <Managesparepartmapping />,
  "/Serialvendorwarranty": <Serialvendorwarranty />,
  "/Customercategory": <Customercategory />,
  "/Viewentitymapping": <Viewentitymapping />,
  "/Manageentitycreditterm": <Manageentitycreditterm />,
  "/Manageentitycredittermmain": <Manageentitycredittermmain />,
  "/Uploadmanageuser": <Uploadmanageuser />,
  "/Uploadentitydetail": <Uploadentitydetail />,
  "/Usermaster": <Usermaster />,
  "/Entitymapping": <Entitymapping />,
  "/Customerservice": <Customerservice />,
  "/Logcomplaint": <Logcomplaint />,
  "/Logproductcomplaint": <Logproductcomplaint />,
  "/Jobsheets": <Jobsheets />,
  "/Jobsheet": <Jobsheet />,
  "/Jobsheet2": <Jobsheet2 />,
  "/Amcdashboard": <Amcdashboard />,
  "/Amc": <Amc />,
  "/CreateCustomerAmc": <CreateCustomerAmc />,
  "/call-dashboard": <CallDashboard />,
  "/Searchdealercustomer": <Searchdealercustomer />,
  "/One": <One />,
  "/inventory-stocktransfer": <Bufferstockallocation />,
  "/JobReport": <JobReport />,
  "/Closecallreport": <Closecallreport />,
  "/Callupdationmobile": <Callupdationmobile />,
  "/Engineerpartconsumption": <Engineerpartconsumption />,
  "/Stockinhand": <Stockinhand />,
  "/Changepassword": <Changepassword />,
  "/Changeadminpassword": <ChangeAdminPassword />,
  "/Jobsheetsearch": <Jobsheetsearch />,
  "/Dashboardsuperadmin": <Dashboardsuperadmin />,
  "/Financialdashboard": <Financialdashboard />,
  "/Dashboardtrails": <Dashboardtrails />,
  "/Subscriptions": <Subscriptions />,
  "/createorganizations": <CreateOrganizations />,
  "/CreateOrganizationsView": <CreateOrganizationsView />,
  "/createpackage": <CreateSubscription />,
  "/module": <ModuleMaster />,
  "/CreateSubscriptionView": <CreateSubscriptionView />,
  "/Manageproductsubcatgeory": <Manageproductsubcatgeory />,
  "/inventory-dashboard": <InventoryDashboard />,
  "/inventory-stockgrn": <StockGRN />,
  "/service-dashboard": <ServiceDashboard />,
  "/change-password-admin": <ChangePasswordAdmin />,
  "/repair-update": <RepairUpdate />,
  "/jobsheetView": <JobsheetView />,
};

function RoutesApp() {
  return (
    <Routes>
      {/* Map through all defined routes and wrap with ProtectedRoute */}
      {Object.entries(routeMapping).map(([path, element]) => (
        <Route 
          key={path} 
          path={path} 
          element={
            path === "/" || path === "/Loginpage" || path === "/createorganizations" || path === "/Customerservice" ? (
              element
            ) : (
              <ProtectedRoute>{element}</ProtectedRoute>
            )
          } 
        />
      ))}
      
      {/* Default redirect for unknown routes */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default RoutesApp;
